import { render, staticRenderFns } from "./kuanView.vue?vue&type=template&id=10fcfb6c"
import script from "./kuanView.vue?vue&type=script&lang=js"
export * from "./kuanView.vue?vue&type=script&lang=js"
import style0 from "./kuanView.vue?vue&type=style&index=0&id=10fcfb6c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports